import { array, mixed, number, object, string } from 'yup';
import { IdNamePairErrorModel, UserRole } from '../../../../../../@data';
import { ArrayObservableSchemaYupType } from '../../../../../../utils';
import { IUserViewModel } from './IUserViewModel';

export function userInvitationErrorModel() {
  return object<IUserViewModel>().shape({
    firstName: string()
      .trim()
      .required(),
    lastName: string()
      .trim()
      .required(),
    emailAddress: string()
      .email()
      .required(),
    localeId: number().required(),
    AccountManagerAccountsSelected: new ArrayObservableSchemaYupType().of(IdNamePairErrorModel).when('accountRole', {
      is: UserRole.AccountManager,
      then: array()
        .min(1)
        .required(),

      otherwise: array()
    }),
    ReportUserAccounstSelected: new ArrayObservableSchemaYupType().of(IdNamePairErrorModel).when('accountRole', {
      is: UserRole.ReportUser,
      then: array()
        .required()
        .min(1),
      otherwise: array()
    }),
    ListManagerAccountsSelected: new ArrayObservableSchemaYupType().of(IdNamePairErrorModel).when('accountRole', {
      is: UserRole.ListManager,
      then: array()
        .required()
        .min(1),
      otherwise: array()
    }),
    AdViewAccountsSelected: new ArrayObservableSchemaYupType().of(IdNamePairErrorModel).when('accountRole', {
      is: UserRole.AdView,
      then: array()
        .required()
        .min(1),
      otherwise: array()
    }),
    accountRole: mixed()
      .oneOf([
        UserRole.AccountManager,
        UserRole.AdView,
        UserRole.ListManager,
        UserRole.PublisherAdmin,
        UserRole.ReportUser,
        UserRole.SuperAdmin
      ])
      .required()
  });
}
